
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let amountText = this.querySelector('.free-shipping--text span');
      let total = Number(this.dataset.cartTotal);
      let minimum = Math.round(Number(this.dataset.minimum) * (Number(window.Shopify?.currency?.rate) || 1));
      if (!Number.isFinite(total) || !Number.isFinite(minimum) || minimum <= 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');

      if (total < minimum) {
        percentage = total / minimum;

        if (amountText) {
          let remaining = minimum - total;
          // El formato del shop es "${{amount_no_decimals}}" y formatMoney() lo imprime
          // al estilo US ("$19,890"). En AR la coma es separador decimal, asi que se
          // fuerza la variante _with_comma_separator (miles con punto: "$19.890"),
          // igual que el subtotal del drawer. Se conserva prefijo/sufijo del formato.
          let format = window.theme.settings.money_with_currency_format || "${{amount_no_decimals_with_comma_separator}}";
          format = format.replace(/\{\{\s*(amount_no_decimals|amount)\s*\}\}/, '{{$1_with_comma_separator}}');
          amountText.innerHTML = formatMoney(remaining, format);
        }

        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'block';
          this.fullText.style.display = 'none';
        }
      } else {
        if (this.remainingText && this.fullText) {
          this.remainingText.style.display = 'none';
          this.fullText.style.display = 'block';
        }
      }

      this.style.setProperty('--percentage', percentage);
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
